module.exports = __webpack_public_path__ + "static/media/Pic-0574.2c9f99e0.jpg";